module.exports = "/_next/static/images/first-home-state_signup-desktop-98d586119b58b9062c312c678e62f53a.png";